import { renderAdminPageContentRenderer } from '@next-adapter/templates/renderers/generators/form-admin/admin-page-content.js'
export function generatePageContent(
  pascal: string,
  kebab: string,
  camel: string,
  label: string,
  actionImportPath: string,
  adminRoutePath = '/admin',
  devModeIntegrateButtonExportName: string,
  devModeIntegrateButtonImportPath: string,
  hasExport = false,
  hasDelete = true
): string {
  const exportIconImport = hasExport ? 'Download, ' : ''
  const exportHookImport = hasExport
    ? `\nimport { useExport${pascal}SubmissionsCSV } from '@admin/hooks/use-${kebab}-form'`
    : ''
  const exportHook = hasExport ? `\n  const exportCsv = useExport${pascal}SubmissionsCSV()` : ''
  const exportSpinnerImport = hasExport
    ? `\nimport { Spinner } from '@admin/components/ui/spinner'`
    : ''
  const exportButton = hasExport
    ? renderAdminPageContentRenderer({ kind: 'renderPageContentActionButtonsTemplate' })
    : ''
  const queryClientImport = hasDelete ? ', useQueryClient' : ''
  const deleteActionImport = hasDelete
    ? `\nimport { deleteBulk${pascal}Submissions } from '@admin/actions/${actionImportPath}'`
    : ''
  const deleteDialogImport = hasDelete
    ? `\nimport { DeleteDialog } from '@admin/components/shared/delete-dialog'`
    : ''
  const toastImport = hasDelete ? `\nimport { toast } from 'sonner'` : ''
  const queryClient = hasDelete ? `  const queryClient = useQueryClient()\n` : ''
  const deleteTransition = hasDelete
    ? `  const [isPending, startTransition] = React.useTransition()\n`
    : ''
  const bulkDeleteHandler = hasDelete
    ? renderAdminPageContentRenderer({
        kind: 'renderPageContentHandleBulkDeleteTemplate',
        props: { pascal: pascal, camel: camel }
      })
    : ''
  const bulkDeleteActions = hasDelete
    ? renderAdminPageContentRenderer({ kind: 'renderPageContentLayoutTemplate' })
    : ''
  return renderAdminPageContentRenderer({
    kind: 'renderPageContentClientModuleTemplate',
    props: {
      queryClientImport: queryClientImport,
      exportIconImport: exportIconImport,
      toastImport: toastImport,
      deleteActionImport: deleteActionImport,
      deleteDialogImport: deleteDialogImport,
      exportSpinnerImport: exportSpinnerImport,
      devModeIntegrateButtonExportName: devModeIntegrateButtonExportName,
      devModeIntegrateButtonImportPath: devModeIntegrateButtonImportPath,
      exportHookImport: exportHookImport,
      pascal: pascal,
      kebab: kebab,
      queryClient: queryClient,
      camel: camel,
      exportHook: exportHook,
      deleteTransition: deleteTransition,
      bulkDeleteHandler: bulkDeleteHandler,
      label: label,
      exportButton: exportButton,
      adminRoutePath: adminRoutePath,
      toLowerCase: label.toLowerCase(),
      bulkDeleteActions: bulkDeleteActions
    }
  })
}
